import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RolesPageComponent } from './containers/roles-page/roles-page.component';
import { RoleListComponent } from './components/role-list/role-list.component';
import { RolesService } from './services/roles.service';
import { RolesEffects } from './store/roles.effects';
import { reducer, ROLES_FEATURE_KEY } from './store/roles.reducer';
import { SharedModule } from '@shared';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

const CONTAINERS = [RolesPageComponent, RoleListComponent];

const COMPONENTS = [];

@NgModule({
  declarations: [...CONTAINERS, ...COMPONENTS],
  providers: [RolesService],
  imports: [
    CommonModule,
    SharedModule,
    NgbTooltipModule,
    EffectsModule.forFeature([RolesEffects]),
    StoreModule.forFeature(ROLES_FEATURE_KEY, reducer),
  ],
})
export class RolesModule {}
